<div class="container">
  <div class="row">
    <div class="col-12" style="display: flex; justify-content: center; align-items: center;">
      <img class="coverImage" width="700px" [src] = "imageUrl" alt="Logo">
    </div>
  </div>
  <div class="row m-5">
    <div class="col-12 d-flex justify-content-center flex-wrap">
      <h1 class="title" style="font-weight: bold">{{labels.lblWelcomeMessage}}</h1>
    </div>
  <div class="row m-2">
    <div class="col-12 d-flex justify-content-center flex-wrap">
      <button class="btn btn-secondary mx-5 my-3" routerLink="/login">{{labels.lblLogin}}</button>
    </div>
  </div>
  <div class="row m-2">
    <div class = "col-12 d-flex justify-content-center" style = "text-align: left">
      <span>
        <span [matMenuTriggerFor]="langMenu">
          @if (lang=='srb') {
            <img style="width: 46px; height: 46px; cursor: pointer;" class="flag" alt = "serbian flag"
              src="./assets/icons/SrpFlgIcon.png" alt="">
            }
            @if (lang=='cirilica') {
              <img style="cursor: pointer;" class="flag" alt = "cyrillic flag"
                src="./assets/icons/SrpFlgIcon.png" alt="">
              }
              @if (lang=='eng') {
                <img style="width: 46px; height: 46px; cursor: pointer;" class="flag" alt = "english flag"
                  src="./assets/icons/EngFlgIcon.png" alt="">
                }
              </span>
              <mat-menu #langMenu="matMenu" class = "langMenu" style = "padding-left: 10px;">
                <!--<button mat-menu-item class="menuButton" (click)="selectLang('srb')">
                  <img class = "flag" src="./assets/icons/SrpFlgIcon.png" alt="" style = "width: 46px; height: 46px;">
                  <span class="aligned-with-icon-lang"> {{labels.lblSerbian}}</span> @if (lang == 'srb') {
                  <mat-icon style = "vertical-align: middle; padding-left: 30px; color: #0E0D35;">done</mat-icon>
                }
              </button>-->
              <button mat-menu-item class="menuButton" (click)="selectLang('cirilica')" style = "margin-top: 10px;">
              <img class="flag" src="./assets/icons/SrpFlgIcon.png" alt="">
              <span class="aligned-with-icon-lang"> {{labels.lblSerbianCyrillic}}</span> <mat-icon *ngIf = "lang == 'cirilica'" style = "vertical-align: middle; padding-left: 30px; color: #0E0D35;">done</mat-icon>
            </button>
            <button mat-menu-item class="menuButton" (click)="selectLang('eng')" style = "margin-top: 10px;">
              <img class="flag" style="width: 46px; height: 46px;"
                src="./assets/icons/EngFlgIcon.png"
                alt="">
              <span class="aligned-with-icon-lang"> {{labels.lblEnglish}}</span> @if (lang == 'eng') {
              <mat-icon style = "vertical-align: middle; padding-left: 30px; color: #0E0D35;">done</mat-icon>
            }
          </button>
        </mat-menu>
      </span>
    </div>
  </div>
</div>
